import { tokens } from '@news-mono/design-tokens'
import {
    BreakpointState,
    calcRem,
    ThemeConfig,
    TheNightlyTheme,
    TheNightlyThemeConfig,
} from '../../../__styling'

export type LeadCardTheme<T extends ThemeConfig> = {
    heading: {
        textType: T['textType']
    }
    byline: {
        textType: T['textType']
        textColor: string
    }
    topic: {
        textType: T['textType']
        textColor: string
    }
    marginTop: BreakpointState<T, string>
}

const { neutral } = tokens.thenightly.colors.palette

export const theNightlyLeadCardTheme = (scheme: TheNightlyTheme) => {
    const theme: LeadCardTheme<TheNightlyThemeConfig> = {
        heading: {
            textType: 'article-main',
        },
        byline: {
            textType: 'byline-secondary',
            textColor: neutral[60],
        },
        topic: {
            textType: 'byline-primary',
            textColor: neutral[60],
        },
        // Negative margins so that it sits flush with the top of the page.
        marginTop: {
            default: calcRem(-40),
            sm: 'unset',
            lg: 'unset',
        },
    }
    return theme
}
